export enum REPORTS {
  REPORTS = 'REPORTS',
  REPORTS_CONFIG = 'REPORTS_CONFIG',
  REPORT_STATUS = 'REPORT_STATUS',
}
